import React from 'react';
import styles from './MenuItemCard.module.css';
import { MenuItem } from 'models/digitalMap';
import { useCurrencyFormatter } from 'components/Map/useCurrencyFormatter';
import clsx from 'clsx';

interface MenuItemProps {
  item: MenuItem;
  isSingle?: boolean;
  isDoubleWide?: boolean;
  onClick: () => void;
}

export const MenuItemCard: React.FC<MenuItemProps> = ({
  item,
  isSingle,
  isDoubleWide,
  onClick,
}) => {
  const thumbnail = item.media_items.find((mediaItem) => mediaItem.type === 'IMAGE')?.url;

  const currencyFormatter = useCurrencyFormatter();

  return (
    <article
      className={clsx(styles.menuItem, {
        [styles.fullWidth]: isSingle,
        [styles.halfWidth]: isDoubleWide,
      })}
      onClick={onClick}
    >
      <div className={styles.imageWrapper}>
        {thumbnail ? (
          <img
            src={thumbnail}
            alt={item.name}
            className={clsx(styles.itemImage, isSingle && styles.single)}
          />
        ) : (
          <div className={styles.noImageBackground}>
            <img
              src="/static/images/map/fork_spoon_white.svg"
              alt="No image"
              className={styles.noImageIcon}
            />
          </div>
        )}
      </div>
      <div className={styles.content}>
        <div className={styles.contentInner}>
          <div className={styles.nameContainer}>
            <div className={styles.itemName}>{item.name}</div>
            <div className={styles.price}>{currencyFormatter.format(item.price)}</div>
          </div>
          <div className={styles.description}>{item.description}</div>
        </div>
      </div>
    </article>
  );
};
